import { type Ref, ref } from "vue"
import { defineStore } from "pinia"
import type { IncomingInvoice } from "@/models/incoming-invoice.model.ts"

export const useIncomingInvoiceStore = defineStore("incomingInvoiceStore", () => {
  const incomingInvoices: Ref<IncomingInvoice[]> = ref([])

  return {
    incomingInvoices
  }
})
